/*
 * brand.js - Sets the title and colours to use
 */
'use strict';

Sao.config.title = 'Advanced Factors';
Sao.config.icon_colors = '#777,#777,#d9534f'.split(',');
